const mutations = {
  setInfo(state, payload) {
    state.info = payload;
  },
  setStudentWasValidated(state, { isValid, message, extraInfo }) {
    state.wasStudentValidated = isValid;
    state.wasStudentValidatedMessage = message;
    state.confirmationNumber = extraInfo;
  },
  setNotificationWays(state, payload) {
    state.catalog.notificationWays = payload;
  },
  setQuestionnaire(state, payload) {
    state.questionnaire = payload;
  },
  setConfirmationNumber(state, payload) {
    state.confirmationNumber = payload;
  },
  setErrorQuestionnaire(state) {
    state.questionnaire = state.questionnaire.map((x) => {
      if (x.questions.filter((s) => !s.selected).length > 0) {
        x.hasError = true;
      } else {
        x.hasError = false;
      }
      return x;
    });
  },
  setCurrentNotificationWay(state, payload) {
    state.info.selectedNotificationWay = payload;
  },
};

export default mutations;
